<script setup>
import { ref } from "vue"

defineProps({
  csrfToken: { type: String, default: "" },
  currentUser: { type: Object, default: null },
  management: { type: Object, default: null },
  semesters: { type: Array, default: () => [] },
  schools: { type: Array, default: () => [] },
  signInPath: { type: String, required: true },
  signOutPath: { type: String, required: true },
})

const mobileOpen = ref(false)
const openMenu = ref(null)

function toggleMenu(menu) {
  openMenu.value = openMenu.value === menu ? null : menu
}
</script>

<template>
  <nav class="site-nav no-print" aria-label="主要導覽列">
    <div class="site-nav__inner">
      <a class="site-nav__brand" href="/">
        <span class="site-nav__brand-mark" aria-hidden="true">IEP</span>
        <span>特教個案管理系統</span>
      </a>

      <button
        class="site-nav__toggle"
        type="button"
        :aria-expanded="mobileOpen"
        aria-controls="primary-navigation"
        @click="mobileOpen = !mobileOpen"
      >
        <span class="sr-only">開啟導覽選單</span>
        <span aria-hidden="true">☰</span>
      </button>

      <div id="primary-navigation" class="site-nav__content" :class="{ 'is-open': mobileOpen }">
        <div class="site-nav__links">
          <a class="site-nav__link" href="/">首頁</a>

          <div v-if="management" class="site-nav__menu">
            <button class="site-nav__link" type="button" :aria-expanded="openMenu === 'management'" @click="toggleMenu('management')">
              管理{{ management.schoolName }} <span aria-hidden="true">⌄</span>
            </button>
            <div v-show="openMenu === 'management'" class="site-nav__dropdown">
              <a v-for="item in management.items" :key="item.path" :href="item.path">{{ item.label }}</a>
            </div>
          </div>

          <div v-if="currentUser" class="site-nav__menu">
            <button class="site-nav__link" type="button" :aria-expanded="openMenu === 'context'" @click="toggleMenu('context')">
              {{ currentUser.semesterName || "未設定學期" }} <span aria-hidden="true">⌄</span>
            </button>
            <div v-show="openMenu === 'context'" class="site-nav__dropdown">
              <span class="site-nav__dropdown-label">切換學期</span>
              <a v-for="item in semesters" :key="item.path" :href="item.path">{{ item.label }}</a>
              <span class="site-nav__dropdown-label">切換學校</span>
              <a v-for="item in schools" :key="item.path" :href="item.path">{{ item.label }}</a>
              <a :href="currentUser.editPath">其他設定</a>
            </div>
          </div>

          <div v-if="currentUser" class="site-nav__menu">
            <button class="site-nav__link" type="button" :aria-expanded="openMenu === 'account'" @click="toggleMenu('account')">
              {{ currentUser.name }}
              <span v-if="currentUser.notificationsCount" class="site-nav__count">{{ currentUser.notificationsCount }}</span>
              <span aria-hidden="true">⌄</span>
            </button>
            <div v-show="openMenu === 'account'" class="site-nav__dropdown site-nav__dropdown--right">
              <a :href="currentUser.notificationsPath">未讀訊息（{{ currentUser.notificationsCount }}）</a>
              <a :href="currentUser.passkeysPath">指紋或人臉辨識</a>
              <a v-if="currentUser.aiProviderPath" :href="currentUser.aiProviderPath">AI 提供者設定</a>
              <form :action="signOutPath" method="post">
                <input type="hidden" name="_method" value="delete">
                <input type="hidden" name="authenticity_token" :value="csrfToken">
                <button type="submit">登出</button>
              </form>
            </div>
          </div>

          <a v-else :href="signInPath" class="site-nav__link">登入</a>

          <div class="site-nav__menu">
            <button class="site-nav__link" type="button" :aria-expanded="openMenu === 'about'" @click="toggleMenu('about')">
              關於我們 <span aria-hidden="true">⌄</span>
            </button>
            <div v-show="openMenu === 'about'" class="site-nav__dropdown site-nav__dropdown--right">
              <a href="/about">系統簡介</a>
              <a href="/contact">聯絡方式</a>
              <a href="/privacy">隱私權宣告</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>
